<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="confirmationModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="ci-container">
    <h2 class="ci-heading">{{constants.heading}}</h2>

    <div class="ci-content">
      <div class="ci-message">
        <h3 class="ci-next">{{constants.whatsNext}}</h3>

        <div class="ci-step" *ngFor="let step of constants.steps; let i = index">
          <span class="ci-step-number">{{i + 1}}</span>
          <p class="ci-step-text">{{step}}</p>
        </div>

        <button type="button" class="btn common-btn-secondary" (click)="closeModal()">{{constants.gotIt}}</button>
      </div>
    </div>
  </div>
</div>
